function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
import { defineComponent, $props, setup as _setup, h } from "@opentiny/vue-common";
import { renderless, api } from "@opentiny/vue-renderless/modal/vue";
import Button from "@opentiny/vue-button";
import Checkbox from "@opentiny/vue-checkbox";
import CheckboxGroup from "@opentiny/vue-checkbox-group";
import { IconHelpSolid, IconInfoSolid, IconSuccess, IconWarning, IconError, IconLoading, IconInfoCircle, IconSuccessful, IconCueL, IconOperationfaildL, IconMinscreenLeft, IconFullscreenLeft, IconClose } from "@opentiny/vue-icon";
function normalizeComponent(scriptExports, render, staticRenderFns, functionalTemplate, injectStyles, scopeId, moduleIdentifier, shadowMode) {
  var options = typeof scriptExports === "function" ? scriptExports.options : scriptExports;
  if (render) {
    options.render = render;
    options.staticRenderFns = staticRenderFns;
    options._compiled = true;
  }
  if (functionalTemplate) {
    options.functional = true;
  }
  if (scopeId) {
    options._scopeId = "data-v-" + scopeId;
  }
  var hook;
  if (moduleIdentifier) {
    hook = function hook2(context) {
      context = context || // cached call
      this.$vnode && this.$vnode.ssrContext || // stateful
      this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext;
      if (!context && typeof __VUE_SSR_CONTEXT__ !== "undefined") {
        context = __VUE_SSR_CONTEXT__;
      }
      if (injectStyles) {
        injectStyles.call(this, context);
      }
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier);
      }
    };
    options._ssrRegister = hook;
  } else if (injectStyles) {
    hook = shadowMode ? function() {
      injectStyles.call(this, (options.functional ? this.parent : this).$root.$options.shadowRoot);
    } : injectStyles;
  }
  if (hook) {
    if (options.functional) {
      options._injectStyles = hook;
      var originalRender = options.render;
      options.render = function renderWithStyleInjection(h, context) {
        hook.call(context);
        return originalRender(h, context);
      };
    } else {
      var existing = options.beforeCreate;
      options.beforeCreate = existing ? [].concat(existing, hook) : [hook];
    }
  }
  return {
    exports: scriptExports,
    options
  };
}

var mode = {
  tiny_mode: "mobile-first"
};
var STATUS_MAPPING_COMPINENT = {
  QUESTION: IconHelpSolid(mode),
  INFO: IconInfoSolid(mode),
  SUCCESS: IconSuccess(mode),
  WARNING: IconWarning(mode),
  ERROR: IconError(mode),
  LOADING: IconLoading(mode)
};
var MOBILE_STATUS_MAPPING_COMPINENT = {
  INFO: IconInfoCircle(mode),
  SUCCESS: IconSuccessful(mode),
  WARNING: IconCueL(mode),
  ERROR: IconOperationfaildL(mode),
  LOADING: IconLoading(mode)
};
var __vue2_script = defineComponent({
  emits: ["zoom", "update:modelValue", "show", "hide", "custom-mousemove", "custom-mouseup", "custom-mousedown"],
  props: _extends({}, $props, {
    animat: {
      type: Boolean,
      default: function _default() {
        return true;
      }
    },
    beforeClose: Function,
    duration: {
      type: [Number, String],
      default: function _default2() {
        return 3e3;
      }
    },
    escClosable: Boolean,
    events: Object,
    fullscreen: Boolean,
    height: [Number, String],
    id: String,
    isFormReset: {
      type: Boolean,
      default: true
    },
    lockScroll: Boolean,
    lockView: {
      type: Boolean,
      default: function _default3() {
        return true;
      }
    },
    marginSize: {
      type: [Number, String],
      default: 10
    },
    mask: {
      type: Boolean,
      default: function _default4() {
        return true;
      }
    },
    maskClosable: Boolean,
    message: [String, Function],
    minHeight: {
      type: [Number, String],
      default: function _default5() {
        return 200;
      }
    },
    minWidth: {
      type: [Number, String],
      default: function _default6() {
        return 340;
      }
    },
    modelValue: Boolean,
    resize: Boolean,
    showFooter: Boolean,
    showHeader: {
      type: Boolean,
      default: true
    },
    status: {
      type: [String, Object],
      default: ""
    },
    title: String,
    top: {
      type: [Number, String],
      default: 80
    },
    type: {
      type: String,
      default: "alert"
    },
    vSize: String,
    width: [Number, String],
    zIndex: [Number, String],
    description: String,
    options: Array,
    showClose: {
      type: Boolean,
      default: true
    },
    confirmContent: String,
    cancelContent: String
  }),
  components: {
    Button,
    Checkbox,
    CheckboxGroup
  },
  provide: function provide() {
    return {
      dialog: this
    };
  },
  setup: function setup(props, context) {
    return _setup({
      props,
      context,
      renderless,
      api,
      extendOptions: {
        isMobileFirstMode: true
      }
    });
  },
  render: function render() {
    var _this = this;
    var state = this.state, slots = this.slots, type = this.type, resize = this.resize, status = this.status, showHeader = this.showHeader, showFooter = this.showFooter, title = this.title, message = this.message, mask = this.mask, t = this.t, description = this.description, options = this.options, showClose = this.showClose, confirmContent = this.confirmContent, cancelContent = this.cancelContent, m = this.m, position = this.position, modalBoxClass = this.modalBoxClass;
    var zoomLocat = state.zoomLocat, visible = state.visible, contentVisible = state.contentVisible, modalTop = state.modalTop, isMsg = state.isMsg;
    var defaultSlot = slots.default;
    var footerSlot = slots.footer;
    var isBottomRight = position === "bottom-right";
    var statusIcon = typeof status === "string" ? STATUS_MAPPING_COMPINENT[status.toUpperCase()] : status;
    var mobileStatusIcon = typeof status === "string" ? MOBILE_STATUS_MAPPING_COMPINENT[status.toUpperCase()] : status;
    var messageHtml = typeof message === "function" ? message.call(this, h) : message;
    var optionsComponent = options ? h(CheckboxGroup, {
      props: {
        tiny_mode: "mobile-first",
        modelValue: state.options,
        vertical: true
      },
      on: {
        "update:modelValue": function updateModelValue(value) {
          state.options = value;
        }
      }
    }, [options.map(function(item) {
      return h(Checkbox, {
        props: {
          tiny_mode: "mobile-first",
          label: item.value,
          name: item.name
        }
      }, [item.label]);
    })]) : null;
    var footerBottom = [h(
      "div",
      // pc 端按钮
      {
        class: "hidden sm:block"
      },
      [type === "confirm" ? h(Button, {
        class: "ml-2 min-w-[theme(spacing.18)]",
        props: {
          tiny_mode: "mobile-first"
        },
        on: {
          click: this.cancelEvent
        }
      }, cancelContent || t("ui.buttonMessage.cancel")) : null, h(Button, {
        class: "ml-2 min-w-[theme(spacing.18)]",
        props: {
          tiny_mode: "mobile-first",
          type: "primary"
        },
        on: {
          click: this.confirmEvent
        }
      }, confirmContent || t("ui.buttonMessage.confirm"))]
    ), h(
      "div",
      // mobile 端按钮
      {
        class: "flex sm:hidden text-base justify-center"
      },
      [type === "confirm" ? h(Button, {
        props: {
          tiny_mode: "mobile-first",
          type: "text",
          buttonClass: "flex-1 text-color-text-secondary active:text-color-text-secondary"
        },
        on: {
          click: this.cancelEvent
        }
      }, t("ui.button.cancel")) : null, type === "confirm" ? h("span", {
        class: "border-r border-r-color-border-separator"
      }) : null, h(Button, {
        props: {
          tiny_mode: "mobile-first",
          type: "text",
          buttonClass: "flex-1 text-color-brand active:text-color-brand"
        },
        on: {
          click: this.confirmEvent
        }
      }, t("ui.button.confirm"))]
    )];
    return h("div", {
      attrs: {
        "data-tag": "tiny-modal"
      },
      class: ["fixed inset-0 w-full h-full text-sm text-color-text-primary transition-top ease-out duration-300", {
        'before:content-[""] before:fixed before:inset-0 before:w-full before:h-full before:opacity-30 before:bg-black': mask,
        "before:pointer-events-none pointer-events-none": !mask,
        "hidden": !contentVisible && !visible
      }, {
        "flex items-center top-0 sm:flex-none sm:items-start": type === "message"
      }],
      style: {
        zIndex: this.state.modalZindex,
        top: modalTop ? modalTop + "px" : null
      },
      on: {
        click: this.selfClickEvent
      }
    }, [h("div", {
      ref: "modalBox",
      attrs: {
        "data-tag": "tiny-grid-modal__box"
      },
      class: m("absolute pointer-events-auto box-border", {
        "bottom-0 sm:bottom-auto top-auto w-full flex sm:block max-h-full": !isMsg
      }, {
        "h-full": zoomLocat
      }, {
        "sm:max-h-[60%]": !zoomLocat
      }, {
        "sm:w-[theme(spacing.112)]": !zoomLocat && type !== "message"
      }, {
        "left-1/2 -translate-x-1/2": !isBottomRight && !zoomLocat
      }, {
        "sm:top-1/2 sm:-translate-y-1/2": !isBottomRight && !isMsg && !zoomLocat
      }, {
        "sm:bottom-0 sm:right-0": isBottomRight
      }, {
        "rounded m-0 px-3 py-2 sm:px-4 sm:py-2.5 sm:w-auto min-w-[theme(spacing.20)] max-w-[theme(spacing.64)] sm:min-w-[theme(spacing.32)] sm:max-w-[theme(spacing.144)] box-border sm:shadow-lg": type === "message"
      }, {
        "bg-color-icon-primary opacity-80 sm:opacity-100 text-white sm:text-color-text-primary sm:bg-white ": type === "message"
      }, modalBoxClass)
    }, [h("div", {
      class: ["flex flex-col w-full max-h-full rounded-lg sm:rounded  overflow-hidden", {
        "shadow-xl bg-white": type !== "message"
      }, {
        "h-full": zoomLocat
      }]
    }, [[showHeader || type === "message" ? h("div", {
      class: ["flex text-sm items-center", {
        "px-6 pt-5 sm:pt-6 leading-6": type !== "message"
      }, {
        "leading-4 sm:leading-5.5 sm:h-auto bg-color-icon-primary text-white sm:text-color-text-primary sm:bg-white": type === "message"
      }],
      on: {
        mousedown: this.mousedownEvent
      }
    }, [status ? [h(statusIcon, {
      props: {
        tiny_mode: "mobile-first"
      },
      class: m("hidden sm:inline-block mr-2 fill-current", type === "message" ? "h-4.5 w-4.5 self-start shrink-0 mt-0.5" : "h-6 w-auto", {
        "text-color-success": status === "success"
      }, {
        "text-color-info-secondary": ["info", "question"].includes(status)
      }, {
        "text-color-warning": status === "warning"
      }, {
        "text-color-error": status === "error"
      })
    }), h(mobileStatusIcon, {
      props: {
        tiny_mode: "mobile-first"
      },
      class: ["inline-block sm:hidden mr-1.5 fill-current", type === "message" ? "w-5 h-5 self-center shrink-0" : "h-6 w-auto"]
    })] : null, h("span", {
      class: ["flex-auto text-base sm:text-sm", {
        "truncate font-semibold": type !== "message"
      }, {
        "line-clamp-2 text-center leading-5.5 sm:text-left": type === "message"
      }],
      attrs: {
        title: title || t("ui.alert.title")
      }
    }, type === "message" ? messageHtml : title || t("ui.alert.title")), resize ? h(zoomLocat ? IconMinscreenLeft(mode) : IconFullscreenLeft(mode), {
      class: "flex-none h-4 w-4 ml-2 cursor-pointer",
      on: {
        click: this.toggleZoomEvent
      }
    }) : null, showClose ? h(IconClose(mode), {
      class: ["flex-none cursor-pointer", {
        "h-4 w-4 ml-2": type !== "message"
      }, {
        "hidden sm:block w-4 h-4 ml-4 self-start sm:mt-0.5 sm:translate-y-px": type === "message"
      }],
      on: {
        click: this.closeEvent
      }
    }) : null]) : null, type !== "message" ? h("div", {
      class: "flex-auto flex mx-6 mt-4 mb-5 sm:my-6 leading-5 overflow-auto"
    }, [status ? h("div", {
      class: "hidden sm:block mr-8"
    }) : null, h("div", {
      class: "w-full"
    }, defaultSlot ? defaultSlot.call(this, {
      $modal: this
    }, h) : [h("div", {
      class: ["leading-normal", {
        "font-medium": description
      }]
    }, messageHtml), description ? h("div", {
      class: "leading-normal pt-2 sm:pt-4 text-color-text-secondary"
    }, [description]) : null, options ? h("div", {
      class: "leading-normal pt-2 sm:pt-4 text-color-text-secondary"
    }, [optionsComponent]) : null])]) : null, showFooter ? h("div", {
      class: "py-2.5 sm:pb-6 sm:pt-0 px-6 border-t-0.5 sm:border-t-0 border-color-border-separator text-center sm:text-right"
    }, footerSlot ? footerSlot.call(this, {
      $modal: this,
      beforeClose: this.beforeClose
    }, h) : footerBottom) : null, !isMsg && resize ? h("span", ["wl", "wr", "swst", "sest", "st", "swlb", "selb", "sb"].map(function(type2) {
      return h("span", {
        attrs: {
          "data-type": type2
        },
        on: {
          mousedown: _this.dragEvent
        }
      });
    })) : null]])])]);
  }
});
var __vue2_render, __vue2_staticRenderFns;
var __cssModules = {};
var __component__ = /* @__PURE__ */ normalizeComponent(__vue2_script, __vue2_render, __vue2_staticRenderFns, false, __vue2_injectStyles, null, null, null);
function __vue2_injectStyles(context) {
  for (var o in __cssModules) {
    this[o] = __cssModules[o];
  }
}
var mobileFirst = /* @__PURE__ */ function() {
  return __component__.exports;
}();
export {
  mobileFirst as default
};
